module.exports = __webpack_public_path__ + "img/8.06fee537.jpg";